export const HOURS_PER_WORKING_DAY = 8;
export const SECONDS_PER_HOUR = 60 * 60;
export const SECONDS_PER_MINUTE = 60;
export const REQUIRED_SECONDS_PER_DAY = 8 * SECONDS_PER_HOUR;
export const DURATION_SECONDS_PER_DAY = 24 * SECONDS_PER_HOUR;
